import { render } from "./ActivityTypeManagement.vue?vue&type=template&id=938ad150"
import script from "./ActivityTypeManagement.vue?vue&type=script&lang=js"
export * from "./ActivityTypeManagement.vue?vue&type=script&lang=js"

import "./ActivityTypeManagement.vue?vue&type=style&index=0&id=938ad150&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__